
//２点間の距離
const getDistance = (pointA, pointB) =>
{
  return Math.sqrt(Math.pow((pointA.x - pointB.x),2) + Math.pow((pointA.y - pointB.y),2));
}

//２点の角度
const getDegree = (pointA, pointB) => 
{
  return Math.atan2((pointB.y - pointA.y), (pointB.x - pointA.x)) * (180 / Math.PI);
}

//角度をラジアンに変更
const degreeToRadian = (degree) => 
{
  return degree * (Math.PI / 180);
}

//ラジアンを角度に変更
const radianToDegree = (radian) => 
{
  return radian / (Math.PI / 180);
}

//ベクトル取得
const getVector = (pointA, pointB) => 
{
  const degree = getDegree(pointA, pointB);
  const radian = degreeToRadian(degree);
  return new PIXI.Point(Math.cos(radian), Math.sin(radian));
}

//線分と点の距離
const getDistanceToLine = (point, startPoint, endPoint) =>
{
  let a = endPoint.x - startPoint.x;
  let b = endPoint.y - startPoint.y;
  let a2 = a * a;
  let b2 = b * b;
  let r2 = a2 + b2;
  let tt = -(a*(startPoint.x-point.x)+b*(startPoint.y-point.y));
  if( tt < 0 ) {
    return (startPoint.x-point.x)*(startPoint.x-point.x) + (startPoint.y-point.y)*(startPoint.y-point.y);
  }
  if( tt > r2 ) {
    return (endPoint.x-point.x)*(endPoint.x-point.x) + (endPoint.y-point.y)*(endPoint.y-point.y);
  }
  let f1 = a*(startPoint.y-point.y)-b*(startPoint.x-point.x);
  return (f1*f1)/r2;
}


const MathUtil = {
  getDistance: getDistance,
  getDegree: getDegree,
  degreeToRadian: degreeToRadian,
  radianToDegree: radianToDegree,
  getVector: getVector,
  getDistanceToLine: getDistanceToLine
}
export default MathUtil